export function shouldUseTouchLayout() {
  if (typeof window === "undefined") return false;

  const compactViewport = window.matchMedia("(max-width: 1100px)").matches;
  if (compactViewport) return true;

  const screenMin = Math.min(window.screen.width, window.screen.height);
  const screenMax = Math.max(window.screen.width, window.screen.height);
  const coarsePointer = window.matchMedia("(pointer: coarse)").matches;
  const standaloneDisplay = window.matchMedia("(display-mode: standalone)").matches;
  const maxTouchPoints =
    typeof navigator !== "undefined" && typeof navigator.maxTouchPoints === "number" ? navigator.maxTouchPoints : 0;
  const legacyStandalone =
    typeof navigator !== "undefined" && "standalone" in navigator
      ? Boolean((navigator as Navigator & { standalone?: boolean }).standalone)
      : false;
  const isiPadLike =
    typeof navigator !== "undefined" &&
    (/iPad/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && maxTouchPoints > 1));
  const touchCapable = maxTouchPoints > 1;

  if (isiPadLike && screenMin <= 1200 && screenMax <= 1600) return true;

  return (coarsePointer || standaloneDisplay || legacyStandalone) && touchCapable && screenMin <= 1200 && screenMax <= 1600;
}

export function getDesktopUiScale() {
  if (typeof window === "undefined") return 1;
  const widthScale = window.innerWidth / 1600;
  const heightScale = (window.innerHeight - 56) / 900;
  return Math.max(0.8, Math.min(1.16, Math.min(widthScale, heightScale)));
}

export function loadStoredBoolean(key: string, defaultValue: boolean) {
  if (typeof window === "undefined") return defaultValue;
  const raw = window.localStorage.getItem(key);
  if (raw === null) return defaultValue;
  return raw === "true";
}
